import React, { useState, useEffect, useRef } from "react";
import ChatInput from "../components/AskBetsyAI/ChatInput";
import { Typewriter } from "react-simple-typewriter";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../styles/Betsy.css";
import TypewriterMarkdown from "../components/kcgbetsy/typewriter";
import ReactMarkdown from "react-markdown";
import { v4 as uuidv4 } from "uuid";
import Footer from "../components/Footer";
import Header from "../components/Header";
import BetsyQuestion from "../components/AskBetsyAI/BetsyBottomSheet/BetsyQuestion";
import SpeechControls from "../components/SpeechControls";
import Sidebar from "./Sidebar";
import BetsyFooter from "../components/BetsyFooter";
import config from "../config/config.json";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { validateToken } from "./ValidateToken";
import OnScreenMessages from "../OnScreenMessages/messages.json";
import { GoogleGenAI } from "@google/genai";
import axios from "axios";

const ai = new GoogleGenAI({
  apiKey: "AIzaSyB27BJqtApZU3qU7UgIQlc9HGEQlen5vPA",
});

const betsyLogo = "/img/kcgbetsy/Betsy.png";
const userLogo = "/img/kcgbetsy/avatar.avif";

var betsyWelcomeMSg = `Hello there! I'm BETSY — your <u>B</u>ODEX <u>E</u>nhanced <u>T</u>rusted <u>S</u>idekick for <u>Y</u>ou on UTahData.org.

Whether you're a student, policymaker, business leader, or curious citizen, BETSY is here to help you explore Utah's data landscape with clarity, speed, and confidence.

Please go ahead and ask me anything related to Utah.`;

var loggedInbetsyWelcomeMSg = `Hello there! I'm BETSY — your <u>B</u>ODEX <u>E</u>nhanced <u>T</u>rusted <u>S</u>idekick for <u>Y</u>ou on UTahData.org.

Whether you're a student, policymaker, business leader, or curious citizen, BETSY is here to help you explore Utah's data landscape with clarity, speed, and confidence.

Please go ahead and ask me anything related to Utah.`;

const AskBetsyAI = ({ initialQuery }) => {
  let customIndex = 0;
  const scrollRef = useRef();
  const [messages, setMessages] = useState([]);
  const [sessionid, setSessionId] = useState("");
  const messagesEndRef = useRef(null);
  const chatHistoryRef = useRef(null);
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);
  const [snackBarMsg, setSnackbarMsg] = useState(false);
  const [regeneratingMsgId, setRegeneratingMsgId] = useState(null);
  const [validToken, setValidToken] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [regeneratingMsgIndex, setRegeneratingMsgIndex] = useState(null);
  const [input, setInput] = useState("");
  const [userDetails, setUserDetails] = useState({
    step: 0,
    // name: "",
    email: "",
  });

  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("token");
      console.log("Token from localStorage:", token);

      if (!token) {
        setValidToken(false);
        return;
      }

      const { valid, user } = await validateToken(token);
      console.log("Validation Response:", { valid, user });

      if (!valid) {
        setValidToken(false);
        return;
      }

      setValidToken(true);
    };

    checkToken();
  }, []);

  useEffect(() => {
    if (validToken !== null) {
      console.log("✅ Is token valid?", validToken);
    }
  }, [validToken]);

  useEffect(() => {
    const existingSid = localStorage.getItem("utah_chat_session");
    const savedMessages = localStorage.getItem("utah_chat_messages");

    if (existingSid) {
      setSessionId(existingSid);
    } else {
      const sid = uuidv4();
      localStorage.setItem("utah_chat_session", sid);
      setSessionId(sid);
    }

    if (savedMessages) {
      try {
        const parsedMessages = JSON.parse(savedMessages).map((m) => ({
          ...m,
          isAnimated: false,
        }));
        setMessages(parsedMessages);
      } catch (e) {
        console.error("Failed to parse saved chat messages:", e);
        // fallback if corrupted
        setMessages([
          {
            id: uuidv4(),
            sender: "bot",
            text: validToken ? loggedInbetsyWelcomeMSg : betsyWelcomeMSg,
            isAnimated: true,
          },
        ]);
      }
    } else {
      // No previous session — start fresh
      setMessages([
        {
          id: uuidv4(),
          sender: "bot",
          text: validToken ? loggedInbetsyWelcomeMSg : betsyWelcomeMSg,
          isAnimated: true,
        },
      ]);
    }
  }, []);

  useEffect(() => {
    if (messages.length > 0) {
      localStorage.setItem("utah_chat_messages", JSON.stringify(messages));
    }
  }, [messages]);

  const startNewSession = () => {
    const sid = uuidv4();
    localStorage.setItem("utah_chat_session", sid);
    localStorage.removeItem("utah_chat_messages");
    setSessionId(sid);
    setMessages([
      {
        id: uuidv4(),
        sender: "bot",
        text: validToken ? loggedInbetsyWelcomeMSg : betsyWelcomeMSg,
        isAnimated: true,
      },
    ]);
    setUserDetails({
      step: 0,
      name: "",
      email: "",
    });
  };

  const sendFeedback = async (type, msg_id) => {
    try {
      const res = await fetch(config.API_URL + "/betsy/utahdata_feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sessionid,
          message_index: msg_id,
          feedback: type,
          user: validToken
            ? JSON.parse(localStorage.getItem("userDetails"))?.email
            : "Guest User",
        }),
      });

      if (!res.ok) {
        console.error("Failed to send feedback:", await res.text());
        return;
      }
    } catch (err) {
      console.error("Error sending feedback:", err);
    }
  };

  const speakText = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 1; // adjust speed if needed
    speechSynthesis.cancel(); // stop previous speech
    speechSynthesis.speak(utterance);
  };

  const handleLike = (msg_id) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.id === msg_id
          ? { ...msg, feedback: msg.feedback === "like" ? "neutral" : "like" }
          : msg
      )
    );
    sendFeedback("like", msg_id);
  };

  const handleDislike = (msg_id) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.id === msg_id
          ? {
              ...msg,
              feedback: msg.feedback === "dislike" ? "neutral" : "dislike",
            }
          : msg
      )
    );
    sendFeedback("dislike", msg_id);
  };

  useEffect(() => {
    if (initialQuery) {
      handleSend(initialQuery);
      initialQuery = "";
    }
  }, [initialQuery]);

  async function extractFullName(text) {
    const response = await ai.models.generateContent({
      model: "gemini-2.0-flash",
      contents: `Extract full name of the user from this sentence: ${text}. Give only names in response. If you can't find the name please response 'Name not found'`,
      config: {
        systemInstruction:
          "You are an intelligent Ai Assistant. You can extract first, last, middle(optional) name of the user from any sentence.",
      },
    });
    return response.text;
  }

  async function isValidEmail(email) {
    if (typeof email !== "string") return "Not a valid email";

    const trimmedEmail = email.trim();

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailRegex.test(trimmedEmail) ? trimmedEmail : "Not a valid email";
  }

  const handleSend = async (msg, feedback) => {
    if (isTyping) return;

    const feedbackType = feedback || "neutral";
    const typingId = uuidv4();
    const userMsg = { id: uuidv4(), sender: "user", text: msg };

    const userEmail = validToken
      ? JSON.parse(localStorage.getItem("userDetails"))?.email ||
        "Logged-in User"
      : "Guest User";

    // If not logged in, show login prompt
    if (!validToken) {
      setMessages((prev) => [...prev, userMsg]);

      if (userDetails.step === 0) {
        setMessages((prev) =>
          prev
            .filter((m) => m.id !== typingId)
            .concat({
              id: uuidv4(),
              sender: "bot",
              text: `Hi there! It seems you are not logged In. 

**Access to BETSY is available by invitation only**. To request access, please share your email on chat.

If you already have an account, you can log in here: https://utahdata.org/login`,
              // text: "Access to BETSY is by invitation only. Please submit your email & an invite will be sent to you. If already has access Please login at https://utahdata.org/login",
              originalQuestion: msg,
              isAnimated: true,
              stepper: true,
            })
        );
        setUserDetails({ ...userDetails, step: 1 });
        setIsTyping(false);
        return;
      }

      // if (userDetails.step === 1 && !userDetails.name) {
      //   // Save name from user's previous input (msg)
      //   const fullname = await extractFullName(msg);

      //   console.log(fullname);

      //   if (
      //     typeof fullname === "string" &&
      //     fullname.trim() === "Name not found"
      //   ) {
      //     setMessages((prev) =>
      //       prev.concat({
      //         id: uuidv4(),
      //         sender: "bot",
      //         text: `I can't find your name in previous sentence, Please share your full name to continue.`,
      //         originalQuestion: msg,
      //         isAnimated: true,
      //         stepper: true,
      //       })
      //     );
      //     setIsTyping(false);
      //     return;
      //   } else {
      //     setUserDetails({ ...userDetails, name: fullname, step: 2 });

      //     setMessages((prev) =>
      //       prev.concat({
      //         id: uuidv4(),
      //         sender: "bot",
      //         text: `Thanks ${fullname}! Now, please share your email address to continue.`,
      //         originalQuestion: msg,
      //         isAnimated: true,
      //         stepper: true,
      //       })
      //     );
      //     setIsTyping(false);
      //     return;
      //   }
      // }

      if (userDetails.step === 1 && !userDetails.email) {
        const validEmail = await isValidEmail(msg);

        if (
          typeof validEmail === "string" &&
          validEmail.trim() === "Not a valid email"
        ) {
          setMessages((prev) =>
            prev.concat({
              id: uuidv4(),
              sender: "bot",
              text: `It doesn't look like a valid email address. Can you please check and try again?`,
              originalQuestion: msg,
              isAnimated: true,
              stepper: true,
            })
          );

          setIsTyping(false);
          return;
        } else {
          // Save email and finalize registration (msg assumed to be email input)
          setUserDetails({ ...userDetails, email: validEmail, step: 3 });

          try {
            const response = await axios.post(
              config.APP_URL + "/utahdata/register",
              {
                name: userDetails.name || "",
                email: validEmail,
                password: "",
                account_type: "unverified",
              }
            );
            if (response.status === 201) {
              setMessages((prev) =>
                prev.concat({
                  id: uuidv4(),
                  sender: "bot",
                  text: `Thanks, Your registration request has been submitted successfully. You will receive an email notification once your request is accepted.`,
                  originalQuestion: msg,
                  isAnimated: true,
                  stepper: true,
                })
              );
            } else {
              setMessages((prev) =>
                prev.concat({
                  id: uuidv4(),
                  sender: "bot",
                  text:
                    response.data.message ||
                    `Your Registration failed. Please try again.`,
                  originalQuestion: msg,
                  isAnimated: true,
                  stepper: true,
                })
              );
            }
          } catch (err) {
            if (
              err?.response?.data?.message ===
              "This email is already registered."
            ) {
              if (err?.response?.data?.user?.account_type === "Registered") {
                setMessages((prev) =>
                  prev.concat({
                    id: uuidv4(),
                    sender: "bot",
                    text: `This email is already registered. Please check your email inbox for your login credentials.`,
                    originalQuestion: msg,
                    isAnimated: true,
                    stepper: true,
                  })
                );
              } else {
                setMessages((prev) =>
                  prev.concat({
                    id: uuidv4(),
                    sender: "bot",
                    text: `This email is currently under review. You will receive an email once your request is accepted.`,
                    originalQuestion: msg,
                    isAnimated: true,
                    stepper: true,
                  })
                );
              }
            } else {
              setMessages((prev) =>
                prev.concat({
                  id: uuidv4(),
                  sender: "bot",
                  text:
                    err?.response?.data?.message ||
                    `Your Registration failed. Please try again.`,
                  originalQuestion: msg,
                  isAnimated: true,
                  stepper: true,
                })
              );
            }
          }

          setUserDetails({
            step: 0,
            name: "",
            email: "",
          });

          setIsTyping(false);
          return;
        }
      }
      return; // Halt until registration is complete
    }

    // Add user message and typing placeholder
    setMessages((prev) => [
      ...prev,
      userMsg,
      { id: typingId, sender: "bot", text: "Typing...", isTyping: true },
    ]);
    setIsTyping(true);

    try {
      const res = await fetch(config.API_URL + "/betsy/utahdatabetsy", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          question: msg,
          filename: "UI2025.pdf",
          file_hash: "17eb95e2ff4c8555d5245c409e21741a",
          sessionId: sessionid,
          feedback: feedbackType,
          token: validToken,
          user: userEmail,
        }),
      });

      // Custom error handling
      if (res.status === 504) {
        throw new Error("504");
      }
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      const responseText = data.summary;

      const estimatedTypingDuration = responseText.length * 15;

      setMessages((prev) =>
        prev
          .filter((m) => m.id !== typingId)
          .concat({
            id: data.message_id,
            sender: "bot",
            text: responseText,
            time: data.res_time,
            originalQuestion: msg,
            isAnimated: true,
          })
      );

      // Wait for animation to finish
      setTimeout(() => {
        setIsTyping(false);
      }, estimatedTypingDuration);
    } catch (err) {
      console.error("❌ Error sending message:", err);

      let gracefulMsg = OnScreenMessages["BTC-2041"].message;

      if (err.message.includes("Unexpected token '<'")) {
        gracefulMsg = OnScreenMessages["BTC-2031"].message;
      } else if (
        err.message.includes("504") ||
        err.message.includes("timeout")
      ) {
        gracefulMsg = OnScreenMessages["BTC-2011"].message;
      } else if (err.message.includes("401")) {
        gracefulMsg = OnScreenMessages["BTC-2061"].message;
      } else if (err.message.includes("429")) {
        gracefulMsg = OnScreenMessages["BTC-2081"].message;
      } else if (err.message.includes("Failed to fetch")) {
        gracefulMsg = !window.navigator.onLine
          ? OnScreenMessages["BTC-2071"].message
          : OnScreenMessages["BTC-2021"].message;
      } else if (err.message.includes("502")) {
        gracefulMsg = OnScreenMessages["BTC-2051"].message;
      } else {
        gracefulMsg = OnScreenMessages["BTC-2091"].message;
      }

      setMessages((prev) =>
        prev
          .filter((m) => m.id !== typingId)
          .concat({
            id: uuidv4(),
            sender: "bot",
            text: gracefulMsg,
            originalQuestion: msg,
          })
      );
      setIsTyping(false);
    }
  };

  useEffect(() => {
    if (messages.length > 2) {
      messagesEndRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [messages]);

  const copyText = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopySnackbarOpen(true);
      setSnackbarMsg("Copied to Clipboard!");
    } catch {
      setCopySnackbarOpen(true);
      setSnackbarMsg("Failed to copy!");
    }
  };

  const regenerateResponse = async (msg, index) => {
    setRegeneratingMsgIndex(index);
    setIsTyping(true);

    const originalQuestion = msg.originalQuestion;
    const feedback = msg.feedback || "neutral";

    const userEmail = validToken
      ? JSON.parse(localStorage.getItem("userDetails"))?.email ||
        "Logged-in User"
      : "Guest User";

    // Handle unauthenticated user
    if (!validToken) {
      setMessages((prev) =>
        prev.map((m, i) =>
          i === index
            ? {
                ...m,
                text: OnScreenMessages["BTC-2111"],
                originalQuestion,
                feedback: "neutral",
                isAnimated: true,
              }
            : m
        )
      );
      setIsTyping(false);
      setRegeneratingMsgIndex(null);
      return;
    }

    try {
      const res = await fetch(config.API_URL + "/betsy/utahdatabetsy", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          question: originalQuestion,
          filename: "UI2025.pdf",
          file_hash: "17eb95e2ff4c8555d5245c409e21741a",
          sessionId: sessionid,
          feedback,
          token: validToken,
          user: userEmail,
        }),
      });

      if (res.status === 504) {
        throw new Error("504");
      }
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      const responseText = data.summary;

      const estimatedTypingDuration = responseText.length * 15;

      setMessages((prev) =>
        prev.map((m, i) =>
          i === index
            ? {
                ...m,
                id: data.message_id,
                sender: "bot",
                text: responseText,
                time: data.res_time,
                originalQuestion,
                feedback: "neutral",
                isAnimated: true,
              }
            : m
        )
      );

      setTimeout(() => {
        setIsTyping(false);
      }, estimatedTypingDuration);
    } catch (err) {
      console.error("❌ Error regenerating message:", err);

      let gracefulMsg = OnScreenMessages["BTC-2041"].message;

      if (err.message.includes("Unexpected token '<'")) {
        gracefulMsg = OnScreenMessages["BTC-2031"].message;
      } else if (
        err.message.includes("504") ||
        err.message.includes("timeout")
      ) {
        gracefulMsg = OnScreenMessages["BTC-2011"].message;
      } else if (err.message.includes("401")) {
        gracefulMsg = OnScreenMessages["BTC-2061"].message;
      } else if (err.message.includes("429")) {
        gracefulMsg = OnScreenMessages["BTC-2081"].message;
      } else if (err.message.includes("Failed to fetch")) {
        gracefulMsg = !navigator.onLine
          ? OnScreenMessages["BTC-2071"].message
          : OnScreenMessages["BTC-2021"].message;
      } else if (err.message.includes("502")) {
        gracefulMsg = OnScreenMessages["BTC-2051"].message;
      } else {
        gracefulMsg = OnScreenMessages["BTC-2091"].message;
      }

      setMessages((prev) =>
        prev.map((m, i) =>
          i === index
            ? {
                ...m,
                id: uuidv4(),
                sender: "bot",
                text: gracefulMsg,
                originalQuestion,
              }
            : m
        )
      );

      setIsTyping(false);
    }

    setRegeneratingMsgIndex(null);
  };

  const scrollToBottom = () => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
  };

  const checkIfScrolledToBottom = () => {
    const chat = chatHistoryRef.current;
    if (!chat) return;
    const isAtBottom =
      chat.scrollTop + chat.clientHeight >= chat.scrollHeight - 20;
    setShowScrollDown(!isAtBottom);
  };

  useEffect(() => {
    const chat = chatHistoryRef.current;
    if (!chat) return;

    const handleScroll = () => checkIfScrolledToBottom();

    chat.addEventListener("scroll", handleScroll);
    return () => chat.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    checkIfScrolledToBottom();
  }, [messages]);

  return (
    <>
      <div style={{ display: "flex" }}>
        <Header scrollContainerRef={scrollRef} />
        <Sidebar onNewChat={startNewSession} />
        <div className="kcg-chat-window" ref={scrollRef}>
          <div className="betsy-chat-header"></div>
          <div className="ask-betsi-ai-chat-history" ref={chatHistoryRef}>
            {messages.map((msg, idx) => {
              let displayIndex = null;
              if (msg.sender !== "user") {
                displayIndex = customIndex;
                customIndex += 1;
              }

              return (
                <div
                  key={msg.id || idx}
                  style={{
                    display: "flex",
                    justifyContent:
                      msg.sender === "user" ? "flex-end" : "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div
                    className={`chat-bubble ${
                      msg.sender === "user" ? "user" : "bot"
                    }`}
                  >
                    {msg.sender === "user" ? (
                      msg.text
                    ) : msg.isTyping ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={betsyLogo}
                          alt="Betsy"
                          className="betsylogosize"
                        />
                        <div style={{ flex: 1, color: "#ffffff" }}>
                          <Typewriter
                            key={`typing-loader-${idx}`}
                            words={["Typing..."]}
                            loop={1}
                            cursor
                            cursorStyle="|"
                            typeSpeed={10}
                            deleteSpeed={0}
                            delaySpeed={300}
                          />
                        </div>
                      </div>
                    ) : typeof msg.text === "string" &&
                      msg.text.startsWith("Hello there! I'm BETSY") ? (
                      <div
                        style={{ display: "flex", alignItems: "flex-start" }}
                      >
                        <img
                          src={betsyLogo}
                          alt="Betsy"
                          className="betsylogosize"
                        />
                        <div style={{ flex: 1 }}>
                          {msg.isAnimated ? (
                            <TypewriterMarkdown
                              text={
                                validToken
                                  ? loggedInbetsyWelcomeMSg
                                  : betsyWelcomeMSg
                              }
                            />
                          ) : (
                            <ReactMarkdown
                              remarkPlugins={[remarkGfm]}
                              rehypePlugins={[rehypeRaw]}
                              components={{
                                a: ({ href, children }) => (
                                  <a
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#fa9a25",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {children}
                                  </a>
                                ),
                              }}
                            >
                              {validToken
                                ? loggedInbetsyWelcomeMSg
                                : betsyWelcomeMSg}
                            </ReactMarkdown>
                          )}
                        </div>
                      </div>
                    ) : regeneratingMsgIndex === idx ? (
                      <div
                        style={{ display: "flex", alignItems: "flex-start" }}
                      >
                        <img
                          src={betsyLogo}
                          alt="Betsy"
                          className="betsylogosize"
                        />
                        <div style={{ flex: 1, color: "#ffffff" }}>
                          <Typewriter
                            key={`typing-loader-${idx}`}
                            words={["Typing..."]}
                            loop={1}
                            cursor
                            cursorStyle="|"
                            typeSpeed={10}
                            deleteSpeed={0}
                            delaySpeed={300}
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <img
                            src={betsyLogo}
                            alt="Betsy"
                            className="betsylogosize"
                          />
                          {/* <div style={{ flex: 1 }}>
                            {msg.isAnimated ? (
                              <TypewriterMarkdown
                                key={`bot-msg-${msg.id || idx}`}
                                text={
                                  msg.text ===
                                  "As I am Betsy assistant, I can only help you with UTah Data information."
                                    ? "It seems like this question is out-of-context, can you please ask me another question?"
                                    : msg.text
                                }
                              />
                            ) : (
                              <ReactMarkdown>{msg.text}</ReactMarkdown>
                            )}
                          </div> */}
                          <div style={{ flex: 1 }}>
                            {msg.isAnimated ? (
                              typeof msg.text === "string" ? (
                                <TypewriterMarkdown
                                  key={`bot-msg-${msg.id || idx}`}
                                  text={
                                    msg.text.includes(
                                      "As I am Betsy assistant, I can only help you with UTah Data information."
                                    )
                                      ? OnScreenMessages["BTC-2101"].message
                                      : msg.text
                                  }
                                />
                              ) : null // don't render if not a string
                            ) : typeof msg.text === "string" ? (
                              <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={{
                                  a: ({ href, children }) => (
                                    <a
                                      href={href}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "#fa9a25",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      {children}
                                    </a>
                                  ),
                                }}
                              >
                                {msg.text.includes(
                                  "As I am Betsy assistant, I can only help you with UTah Data information."
                                )
                                  ? OnScreenMessages["BTC-2101"].message
                                  : msg.text}
                              </ReactMarkdown>
                            ) : null}
                          </div>
                        </div>
                        <div style={{ marginLeft: "70px" }}>
                          {messages.length > 2 && msg.time && (
                            <p style={{ color: "#fa9a25", fontSize: "12px" }}>
                              Response Time : {msg.time} secs
                            </p>
                          )}
                          {validToken && !msg.stepper && (
                            <>
                              <IconButton
                                onClick={() =>
                                  copyText(
                                    typeof msg.text === "string" &&
                                      msg.text.includes(
                                        "As I am Betsy assistant, I can only help you with UTah Data information."
                                      )
                                      ? OnScreenMessages["BTC-2101"].message
                                      : msg.text
                                  )
                                }
                                size="small"
                                style={{ color: "#fff" }}
                              >
                                <ContentCopyIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                onClick={() => regenerateResponse(msg, idx)}
                                size="small"
                                style={{ color: "#fff" }}
                              >
                                <AutorenewIcon fontSize="small" />
                              </IconButton>

                              <SpeechControls text={msg.text} />

                              <IconButton onClick={() => handleLike(msg.id)}>
                                {msg.feedback === "like" ? (
                                  <ThumbUpAltIcon style={{ color: "#fff" }} />
                                ) : (
                                  <ThumbUpOffAltIcon
                                    style={{ color: "#fff" }}
                                  />
                                )}
                              </IconButton>

                              <IconButton onClick={() => handleDislike(msg.id)}>
                                {msg.feedback === "dislike" ? (
                                  <ThumbDownAltIcon style={{ color: "#fff" }} />
                                ) : (
                                  <ThumbDownOffAltIcon
                                    style={{ color: "#fff" }}
                                  />
                                )}
                              </IconButton>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  {msg.sender === "user" && (
                    <img
                      src={userLogo}
                      alt="User"
                      style={{
                        height: 60,
                        width: 60,
                        marginLeft: "0.5rem",
                        borderRadius: "50%",
                        marginTop: "-20px",
                      }}
                    />
                  )}
                </div>
              );
            })}
            <div ref={messagesEndRef} />
          </div>

          {showScrollDown && (
            <div
              onClick={scrollToBottom}
              className="scroll-down-btn"
              aria-label="Scroll to bottom"
            >
              <ArrowCircleDownIcon style={{ color: "#fff" }} fontSize="large" />
            </div>
          )}

          <ChatInput
            input={input}
            setInput={setInput}
            onSend={handleSend}
            isTyping={isTyping}
          />

          <Snackbar
            open={copySnackbarOpen}
            autoHideDuration={2000}
            onClose={() => setCopySnackbarOpen(false)}
            message={<span className="snackbarmsg">{snackBarMsg}</span>}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            action={
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setCopySnackbarOpen(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          />
        </div>
      </div>
      <BetsyFooter />
      <BetsyQuestion setInput={setInput} />
    </>
  );
};

export default AskBetsyAI;
